"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AccountCircleOutline = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SvgIcon = _interopRequireWildcard(require("./SvgIcon"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var AccountCircleOutline = exports.AccountCircleOutline = function AccountCircleOutline(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], _extends({
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.0001 12.9502c2.1953 0 3.975-1.7797 3.975-3.975s-1.7797-3.975-3.975-3.975c-2.1954 0-3.975 1.7796-3.975 3.975 0 2.1953 1.7796 3.975 3.975 3.975zm2.475-3.975c0 1.3669-1.1081 2.475-2.475 2.475s-2.475-1.1081-2.475-2.475c0-1.367 1.1081-2.475 2.475-2.475s2.475 1.108 2.475 2.475z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.8707 21.2068C20.6637 19.3198 22.5 16.1244 22.5 12.5 22.5 6.701 17.799 2 12 2S1.5 6.701 1.5 12.5c0 3.7929 2.011 7.1161 5.025 8.9614a10.4626 10.4626 0 001.8647.9015C9.5155 22.775 10.7315 23 12 23c1.4068 0 2.7489-.2767 3.9751-.7785a10.4787 10.4787 0 001.8956-1.0147zM12 21.5c1.4269 0 2.7763-.3321 3.9751-.9232v-.3927c0-2.3332-1.7325-4.159-3.975-4.159s-3.975 1.8258-3.975 4.159v.3928c1.1987.591 2.548.9231 3.9749.9231zm.0001-6.9749c2.9619 0 5.2061 2.2846 5.4525 5.1358C19.6086 18.0166 21 15.4208 21 12.5c0-4.9706-4.0294-9-9-9s-9 4.0294-9 9c0 2.9209 1.3914 5.5167 3.5476 7.161.2463-2.8513 2.4905-5.1359 5.4525-5.1359z",
    clipRule: "evenodd"
  }));
};
AccountCircleOutline.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(Object.keys(_SvgIcon.KIND)),
  size: _propTypes["default"].oneOf(Object.keys(_SvgIcon.SIZE)),
  title: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(Object.keys(_SvgIcon.COLOR)),
  htmlColor: _propTypes["default"].string,
  fontSize: _propTypes["default"].oneOf(['medium', 'inherit', 'small', 'large']),
  viewBox: _propTypes["default"].string
} : {};
AccountCircleOutline.defaultProps = {
  viewBox: '0 0 24 24'
};
var _default = exports["default"] = AccountCircleOutline;